import React from "react";

//function for form reset
function handleSubmit(e) {
  setTimeout(() => {
    e.target.reset();
  }, 3000);
}

const Contact = () => {
  return (
    <div name="contact" className="contact w-full h-screen p-4 text-white">
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <h3 className="text-4xl font-bold inline border">Contact</h3>
          <p className="py-6">
            Let's Dive in to Your New Project or Take the Existing One to the
            Next Level
          </p>
        </div>

        <div className=" flex justify-center items-center">
          <form
            onSubmit={handleSubmit}
            name="contact"
            method="POST"
            action="https://getform.io/f/1d09dd28-2797-4663-8290-746978b2d24c"
            className="flex flex-col w-full md:w-1/1"
          >
            <input
              type="text"
              name="name"
              placeholder="Name"
              required
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              required
              className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              placeholder="Message"
              rows="10"
              required
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>

            <button
              type="submit"
              className="text-white px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300 button"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Contact;